import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

@Directive({
  selector: '[stayMgmtContentHeight]'
})
export class ContentHeightDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input() fromParent: boolean;
  @Output() contentHeight: EventEmitter<number>;

  private resize: ResizeObserver;
  private winResize: Observable<number>;
  private heightSub: Subject<number>;
  private resizeSubs: Subscription;

  constructor(private el: ElementRef) {
    this.contentHeight = new EventEmitter();
    this.heightSub = new Subject();
  }

  ngOnInit(): void {
    this.resize = new ResizeObserver(entries => {
      entries.forEach(entry => {
        this.heightSub.next(entry.contentRect.height);
      });
    });
    this.winResize = Observable.fromEvent(window, 'resize').map((event: any) => {
      const elRef = this.el.nativeElement;
      return (this.fromParent ? elRef.parentElement.offsetHeight : elRef.offsetHeight);
    });
  }

  ngAfterViewInit(): void {
    this.resize.observe(this.el.nativeElement);
    this.resizeSubs = Observable.merge(this.winResize, this.heightSub.asObservable())
      .distinctUntilChanged()
      .subscribe(event => { this.contentHeight.emit(event); }, error => Observable.throw(error));
  }

  ngOnDestroy(): void {
    if (this.resizeSubs) {
      this.resizeSubs.unsubscribe();
    }
    this.heightSub.unsubscribe();
    this.resize.unobserve(this.el.nativeElement);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/directives/content-height.directive.ts